/*
 * @Author: your name
 * @Date: 2021-06-07 10:32:07
 * @LastEditTime: 2025-11-14 17:47:44
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\api\product\index.js
 */
import request from '../request';
import { baseOssUrl } from '../urlConfig';

const qs = require('qs');

const baseUrl = request.getBaseUrl();
const server = {
  fileUpload: `${baseUrl}/product/fileUploadForProductImage`,
  fileUploadForProductFile: `${baseUrl}/product/fileUploadForProductFile`,
  fileUploadForDeliver: `${baseUrl}/transaction-center/upload/supplierShip`,
  // 品牌图片上传
  fileUploadForBrand: `${baseUrl}/product/fileUploadForBrand`,
  // 品牌附件上传
  fileUploadForBrandFile: `${baseUrl}/product/fileUploadForBrandFile`,
  // 对账单上传
  fileUploadForStatementAccount: `${baseUrl}/transaction-center/upload/statementAccount`,
  // 导入商品
  importCentralizedSku: `${baseUrl}/product/companyCentralizedSku/importCompanySku`,
  // 导入调价
  importChangePriceCentralized: `${baseUrl}/product/companyCentralizedSku/importCompanyChangePrice`,

  getCategoryByParentId(params) {
    return request.post(
      '/product/category/selectEnableCategoryByParentId',
      params
    );
  },
  // 根据分类获取品牌
  getBrandByCategory(params) {
    return request.post('/product/category/selectCategoryBrandList', params);
  },
  // 根据分类获取属性列表
  getPropertyByCategory(params) {
    return request.post(
      '/product/category/selectCategoryEnableAttributeList',
      params
    );
  },
  // 根据分页分类获取属性列表
  getPropertyByCategoryByPage(params) {
    return request.post(
      '/product/category/selectCategoryEnableAttributeListByPage',
      params
    );
  },

  // 获取可售区域列表
  getSalesArea(params) {
    return request.post('/product/salesScope/querySalesScopeList', params);
  },
  // 判断商品是否存在
  checkProductExist(params) {
    return request.post(
      '/product/productManagement/judgeProductIsExist',
      params
    );
  },
  // 获取分类下单位
  getUnitByCategory(params) {
    return request.post('/product/category/selectCategoryUnitList', params);
  },
  // 商品发布
  submitProduct(params) {
    return request.post('/product/auditManagement/productRelease', params);
  },
  // 非标商品发布
  submitOffstandardProduct(params) {
    return request.post(
      '/product/productAuditNonstandard/submitProductRelease',
      params
    );
  },
  // 非标审核拒绝后再次商品发布
  submitOffstandardProductWithAudit(params) {
    return request.post(
      '/product/productAuditNonstandard/againSubmitProductRelease',
      params
    );
  },
  // 非标编辑后再次商品发布
  submitOffstandardProductWithEdit(params) {
    return request.post(
      '/product/productAuditNonstandard/editSubmitProductRelease',
      params
    );
  },
  // 商品保存草稿箱
  submitProductDrafts(params) {
    return request.post(
      '/product/auditManagement/saveProductReleaseDraft',
      params
    );
  },
  // 获取商品税率
  getTaxRateList(params) {
    return request.fetch(
      '/product/taxrateManagement/queryProductTaxrate',
      params
    );
  },
  // 获取相同属性商品
  getSameAttrSkusByProducId(params) {
    return request.post('/product/skuManagement/querySkusByProducId', params);
  },
  // 商品发布申请规格属性
  createAttributeAudit(params) {
    return request.post('/product/attributeAudit/createAttributeAudit', params);
  },
  // 获取销售规则区域列表
  getSalesScopePage(params) {
    return request.post('/product/salesScope/querySalesScopeByPage', params);
  },
  queryAreaConfig4Inst(params) {
    return request.post('/product/salesScope/queryAreaConfig4Inst', params);
  },
  // 添加销售区域
  addSalesScope(params) {
    return request.post('/product/salesScope/addSalesScope', params);
  },
  // 搜索协议客户小类分类
  selectCategoryRouteList(params) {
    return request.post('/product/category/selectCategoryRouteList', params);
  },
  // 搜索平台小类分类
  selectCategoryRouteListByPlatform(params) {
    return request.post(
      '/product/companyCategory/selectCompanyCategoryRouteList',
      params
    );
  },
  queryAreaConfig4Edit(params) {
    return request.post('/product/salesScope/queryAreaConfig4Edit', params);
  },
  editeSalesScope(params) {
    return request.post('/product/salesScope/editeSalesScope', params);
  },
  salesScopeDelete(params) {
    return request.fetch('/product/salesScope/salesScopeDelete', params);
  },
  // 下载商品上线模板
  downSkuUploadTemplate(params) {
    return request.post('/product/productExcel/downSkuUploadTemplate', params, {
      responseType: 'blob',
    });
  },
  // 分页查询商品发布列表-商品发布列表
  queryUnsubmitProductAuditByPage(params) {
    return request.post(
      '/product/auditManagement/queryUnsubmitProductAuditByPage',
      params
    );
  },
  // 批量删除-商品发布
  unsubmitReleaseDelete(params) {
    return request.post(
      '/product/auditManagement/unsubmitReleaseDelete',
      params
    );
  },
  // 导入商品上线模板
  importSkuTemplate(params) {
    return request.post('/product/productExcel/importSkuTemplate', params);
  },
  // 查询上传历史记录
  selectSkuImportFilePage(params) {
    return request.post('/product/skuImport/selectSkuImportFilePage', params);
  },
  // 销售规则名称查询-为前台作为下拉框数据字典用
  querySalesScopeList(params) {
    return request.post('/product/salesScope/querySalesScopeList', params);
  },
  // 设置可售区域-商品发布
  unsubmitReleaseSalesScopeUpdate(params) {
    return request.post(
      '/product/auditManagement/unsubmitReleaseSalesScopeUpdate',
      params
    );
  },
  // 维护图片-商品发布
  unsubmitReleaseImagesUpdate(params) {
    return request.post(
      '/product/auditManagement/unsubmitReleaseImagesUpdate',
      params
    );
  },
  // 商品分页列表查询-供应商
  querySkuByPage(params) {
    return request.post('/product/skuManagement/querySkuByPage', params);
  },
  // 商品发布审核列表——供应商
  queryReleaseProductByPage(params) {
    return request.post(
      '/product/auditManagement/queryReleaseProductByPage',
      params
    );
  },
  // 下架维护图片 auditManagement/modifyProductImages
  modifyProductImages(params) {
    return request.post('/product/auditManagement/modifyProductImages', params);
  },
  // 导入商品提交审核-商品发布操作
  unsubmitProductReleaseBattch(params) {
    return request.post(
      '/product/auditManagement/unsubmitProductReleaseBattch',
      params
    );
  },
  // 已保存商品提交发布-商品发布编辑提交
  unsubmitProductRelease(params) {
    return request.post(
      '/product/auditManagement/unsubmitProductRelease',
      params
    );
  },
  // 商品编辑信息详情查询 - 维护上下架编辑详情
  querySkuInfoForEdite(params) {
    return request.fetch('/product/skuManagement/querySkuInfoForEdite', params);
  },
  //  商品上架
  skuPutawayBattch(params) {
    return request.post('/product/skuManagement/skuPutawayBattch', params);
  },
  // 商品下架
  skuSoldOutBattch(params) {
    return request.post('/product/skuManagement/skuSoldOutBattch', params);
  },
  // // 批量模块下载 类目
  // selectLeafCategoryList: function(params) {
  //   return request.post("/product/category/selectLeafCategoryList", params);
  // },
  // 批量模块下载 类目
  selectLeafCategoryList(params) {
    // 上面注释掉的是 改掉的之前的接口
    return request.post(
      '/product/companyCategory/selectCompanyCategoryLeafList',
      params,
      { preventRepeat: false }
    );
  },
  // 获取末级类目
  selectCompanyCategoryLeafList(params) {
    return request.post(
      '/product/companyCategory/selectCompanyCategoryLeafList',
      params
    );
  },
  // 查询导入商品详情
  selectByPrimaryKey(params) {
    return request.post('/product/skuImport/selectByPrimaryKey', params);
  },
  // 商品多维度调价
  updateSkuPriceBatch(params) {
    return request.post('/product/skuManagement/updateSkuPriceBatch', params);
  },
  // 商品删除
  skuDeleteBattch(params) {
    return request.post('/product/skuManagement/skuDeleteBattch', params);
  },
  // 商品维护-关联销售区域
  updateSalesAreaScope(params) {
    return request.post('/product/skuManagement/updateSalesAreaScope', params);
  },
  // //商品规格分页查询审核
  // queryAttributeAuditPage: function(params) {
  //   return request.post("/product/attributeAudit/queryAttributeAuditPage", params);
  // },
  // 商品规格分页查询审核
  queryAttributeAuditPage(params) {
    // 上面是改掉的之前的接口
    return request.post(
      '/product/attributeAudit/queryAttributeAuditPageByCompany',
      params,
      { preventRepeat: false }
    );
  },
  // 获取品牌列表
  queryAllBrand(params) {
    return request.post('/product/brand/queryAllBrand', params);
  },
  // 模糊查询品牌列表
  queryBrandByName(params) {
    return request.post('/product/brand/queryBrandByName', params);
  },
  // 获取品牌下的前端类目
  selectCategoryListByBrandId(params) {
    return request.post(
      '/product/category/selectCategoryListByBrandId',
      params
    );
  },
  // 商品详情查询
  querySkuInfoById(params) {
    return request.fetch('/product/skuManagement/querySkuInfoById', params);
  },
  // 导入商品信息编辑
  updateImportSkuInfo(params) {
    return request.post('/product/skuImport/updateImportSkuInfo', params);
  },
  // 获取图库树结构
  getImgTreeFromLibrary(params) {
    return request.post(
      '/product/supplier/productPicture/queryPictureFile',
      params,
      { preventRepeat: false }
    );
  },
  // 获取图库图片
  getImgFromLibrary(params) {
    return request.post(
      '/product/supplier/productPicture/queryPictureImageList',
      params
    );
  },
  // 商品发布审核内容查询-商品维护审核详情
  queryReleaseProductInfoById(params) {
    return request.fetch(
      '/product/auditManagement/queryReleaseProductInfoById',
      params
    );
  },
  // 商品编辑发布-商品维护上下架编辑发布
  productEditRelease(params) {
    return request.post('/product/auditManagement/productEditRelease', params);
  },
  // 导出
  downProductList(params) {
    return request.post('/product/productExcel/downProductList', params, {
      responseType: 'blob',
    });
  },
  // 获取协议分类 - 品牌新增判断有没有可售目录
  getCategoryListByAgreement(params) {
    return request.post(
      '/product/companyCategory/selectCompanyCategoryList',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 获取全平台非标商品类目
  selectNoStandardCompanyCategoryList(params) {
    return request.post(
      '/product/companyCategory/selectNoStandardCompanyCategoryList',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 获取全平台非标商品类目
  selectNoStandardCompanyCategoryList(params) {
    return request.post(
      '/product/companyCategory/selectNoStandardCompanyCategoryList',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 最小起订量修改
  updateOrderMinOrderQuantity(params) {
    return request.post(
      '/product/skuManagement/updateOrderMinOrderQuantity',
      params
    );
  },
  // 修改商品发货周期
  updateSkuDeliverTime(params) {
    return request.post('/product/skuManagement/updateSkuDeliverTime', params);
  },
  // 修改商品订单确认
  updateSkuIsConfirm(params) {
    return request.post('/product/skuManagement/updateSkuIsConfirm', params);
  },
  // 修改商品市场价
  updateSkuPrice(params) {
    return request.post('/product/skuManagement/updateSkuPrice', params);
  },
  // 商品库存修改
  updateSkuStock(params) {
    return request.post('/product/skuManagement/updateSkuStock', params);
  },
  // 修改商品显示顺序
  updateSkuSortNum(params) {
    return request.post('/product/skuManagement/updateSkuSortNum', params);
  },
  // 导入批量维护商品信息
  importSkuEdit(params) {
    return request.post('/product/productExcel/importSkuEdit', params);
  },
  // 导入批量维护商品信息
  downProductEditTemplate(params) {
    return request.post(
      '/product/productExcel/downProductEditTemplate',
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 商品销售范围变更-批量
  updateSkuSalesScopeBattch(params) {
    return request.post(
      '/product/skuManagement/updateSkuSalesScopeBattch',
      params
    );
  },
  // 商品销售范围变更
  updateSkuSalesScope(params) {
    return request.post('/product/skuManagement/updateSkuSalesScope', params);
  },
  // 根据公司Id和categoryId查询是否为此公司可售类目
  queryCategoryByCompanyCategory(params) {
    return request.post(
      '/product/companyCategory/queryCategoryByCompanyCategory',
      params
    );
  },
  // 根据小类ID查询供应商列表
  queryCompanyListByCategoryList(params) {
    return request.post(
      '/product/purchaseAreaCategory/queryCompanyListByCategoryList',
      params
    );
  },
  // 修改
  editPurchaseAreaCategory(params) {
    return request.post(
      '/product/purchaseAreaCategory/editPurchaseAreaCategory',
      params
    );
  },
  // 新增
  addPurchaseAreaCategory(params) {
    return request.post(
      '/product/purchaseAreaCategory/addPurchaseAreaCategory',
      params
    );
  },

  // 下载错误数据
  downSkuUploadErrorMessage(params) {
    return request.post(
      '/product/productExcel/downSkuUploadErrorMessage',
      params,
      {
        responseType: 'blob',
      }
    );
  },

  // 已拒绝商品发布-更新关联图片
  updateReleaseImages(params) {
    return request.post('/product/auditManagement/updateReleaseImages', params);
  },

  // 拒绝商品提交审核
  productReleaseSubmitAgain(params) {
    return request.post(
      '/product/auditManagement/productReleaseSubmitAgain',
      params
    );
  },

  // 新-批量发布下载模版-协议用户
  queryLeafCategoryListByPage(params) {
    return request.post(
      '/product/category/queryLeafCategoryListByPage',
      params
    );
  },

  // 新-批量发布下载模版-全平台
  queryCompanyCategoryLeafListByPage(params) {
    return request.post(
      '/product/companyCategory/queryCompanyCategoryLeafListByPage',
      params
    );
  },
  // 根据供应商查询商品
  getProductBySupplierCompanyId(params) {
    return request.post('/product/mall/queryProductPage', params);
  },
  // 根据供应商查询商品
  queryStoreCompanyCategory(params) {
    return request.post(
      '/product/companyCategory/queryStoreCompanyCategoryListByCompanyId',
      params
    );
  },
  // 修改税率
  taxRateEdite(params) {
    return request.post('/product/skuManagement/taxRateEdite', params);
  },

  // 品牌管理列表
  querySupplyCompanyBrandAuditPage(params) {
    return request.post(
      '/product/brandAudit/querySupplyCompanyBrandAuditPage',
      params
    );
  },
  // 根据name模糊查询品牌信息-品牌审核
  queryBrandInfoByName(params) {
    return request.post('/product/brand/queryBrandInfoByName', params);
  },
  // 新增品牌
  addBrandAudit(params) {
    return request.post('/product/brandAudit/submitBrandAudit', params);
  },
  // 保存品牌
  saveBrand(params) {
    return request.post('/product//brandAudit/saveBrandAudit', params);
  },
  // 根据Id查询品牌详细信息
  queryBrandDetailByBrandId(params) {
    return request.post('/product/brand/queryBrandDetailByBrandId', params);
  },
  // 品牌详情
  queryBrandAuditDetail(params) {
    return request.post('/product/brandAudit/queryBrandAuditDetail', params);
  },
  // 删除商品分类品牌  运营平台
  deleteCategoryBrand(params) {
    return request.post('/product/category/deleteCategoryBrand', params);
  },
  //  编辑品牌审核内容
  modifyBrandAuditContent(params) {
    return request.post('/product/brandAudit/modifyBrandAuditContent', params);
  },

  // ----- 阶梯价 -----
  // PC-商品搜索-阶梯价-上架+全平台商品
  queryProductByPage(params) {
    return request.post('/product/mall/queryProductByPage', params);
  },
  // 1-新增阶梯价
  addStepPrice(params) {
    return request.post('/product/stepPrice/addStepPrice', params);
  },
  // 2-修改阶梯价
  modifyStepPrice(params) {
    return request.post('/product/stepPrice/modifyStepPrice', params);
  },
  // 4-停用启用阶梯价
  modifyStepPriceStatus(params) {
    return request.post('/product/stepPrice/modifyStepPriceStatus', params);
  },
  // 3-通过skuid和供应商id查看阶梯价
  queryStepPrice(params) {
    return request.post('/product/stepPrice/queryStepPrice', params);
  },

  // 4.1通过采购商ID查询供应商列表(参数只有purchaserId)
  querySupplierListByPurchaserId(params) {
    return request.post(
      '/product/purchaseAreaCategory/querySupplierListByPurchaserId',
      params
    );
  },

  // 通过供应商ID查询小类列表 (参数只有purchaserId+supplierCompanyId) 已选择
  queryCategoryListBySupplierCompanyId(params) {
    return request.post(
      '/product/purchaseAreaCategory/queryCategoryListBySupplierCompanyId',
      params
    );
  },

  // 通过供应商id查询小类信息，不分页
  queryCategoryBySupplierCompanyId(params) {
    return request.post(
      '/product/skuManagement/queryCategoryBySupplierCompanyId',
      params
    );
  },

  // 3-新增、修改  供应商小类的添加和修改
  addOrUpdatePurchaseAreaCategory(params) {
    return request.post(
      '/product/purchaseAreaCategory/addOrUpdatePurchaseAreaCategory',
      params
    );
  },

  // 5-生成前台分类树的方法(参数只有purchaserId)
  generateCategoryTree(params) {
    return request.post(
      '/product/purchaseAreaCategory/generateCategoryTree',
      params
    );
  },

  // 删除已添加供应商
  removePurchaseAreaCategory(params) {
    return request.post(
      '/product/purchaseAreaCategory/removePurchaseAreaCategory',
      params
    );
  },
  // 获取平台分类
  getAllCategoryTree(params) {
    return request.fetch('/product/category/queryCategoryTree', params);
  },
  // 查询计划采购-采购商绑定小类
  queryPurchaseCategory(params) {
    return request.post('/product/category/queryPurchaseCategory', params);
  },
  // 新增计划采购-采购商绑定小类
  addPurchaseCategory(params) {
    return request.post('/product/category/addPurchaseCategory', params);
  },
  // 查询公司是否开启了采购申请同步接口权限
  queryIsOpen(params) {
    return request.post('/api-register/tenantConfig/queryIsOpen', params);
  },

  // 是否可选保供平台商品接口
  isSelect(params) {
    return request.fetch('/product/skuTransfer/isSelect', params);
  },

  // 2、根据小类和供应商获取1.0商品列表
  queryByPage(params) {
    return request.post('/product/skuTransfer/queryByPage', params);
  },

  // 单个和批量添加商品接口
  batchAdd(params) {
    return request.post('/product/skuTransfer/batchAdd', params);
  },

  // 4、根据小类和供应商添加全部商品
  addAll(params) {
    return request.post('/product/skuTransfer/addAll', params);
  },

  // 获取我要出口商品列表
  pushExportList(params) {
    return request.post('/product-interflow/push/exportList', params);
  },

  // 提交我要出口
  pushExport(params) {
    return request.post('/product-interflow/push/export', params);
  },
  // 库存信息
  queryStoreInfo(params) {
    return request.post(
      '/data-center/thirdSupplierStock/queryThirdSupplierStock',
      params
    );
  },
  //  商品撤销提交审核
  modifyRevokeSubmitReview(params) {
    return request.post(
      '/product/auditManagement/modifyRevokeSubmitReview',
      params
    );
  },
  // 获取平台可用类目
  usefulCategoryTree(params) {
    return request.fetch('/product/category/usefulCategoryTree', params);
  },
  // 获取保供平台全平台分类树
  getAllCategoryListBySupplier(params) {
    return request.fetch(
      '/product/companyCategory/transferCompanyCategoryList',
      params
    );
  },
  // 获取保供平台协议分类树
  getAgreementCategoryListBySupplier(params) {
    return request.fetch('/product/category/transferCategoryTree', params);
  },
  // 获取保供平台全平台商品分类搜索
  searchAllCategoryListBySupplier(params) {
    return request.post(
      '/product/companyCategory/transferCompanyCategoryRouteList',
      params
    );
  },
  // 获取保供平台协议商品分类搜索
  searchAgreementCategoryListBySupplier(params) {
    return request.post('/product/category/transferCategoryRouteList', params);
  },
  // 获取全平台非标商品分类搜索路径
  selectNoStandardCompanyCategoryRouteList(params) {
    return request.post(
      '/product/companyCategory/selectNoStandardCompanyCategoryRouteList',
      params
    );
  },
  // 删除拒绝品牌
  removeBrand(params) {
    return request.post('/product/brandAudit/removeBrand', params);
  },
  // 删除规格审核
  deleteAttributeAudit(params) {
    return request.post('/product/attributeAudit/deleteAttributeAudit', params);
  },
  // 共享协议附件上传
  fileUploadForShareAgreementFile() {
    return `${baseUrl}/product/fileUploadForShareAgreementFile`;
  },
  // 商品交货期变更
  updateSkuDeliveryType(params) {
    return request.post('/product/skuManagement/updateSkuDeliveryType', params);
  },
  //
  querySupplier(params) {
    return request.post(
      '/user-center/search/searchSupplierForProductDetail',
      params
    );
  },
  queryMDMCodeByCategoryId(params) {
    return request.post('/product/category/queryMDMCodeByCategoryId', params);
  },
  queryContact(params) {
    return request.post('/user-center/company/queryContactsForProduct', params);
  },
  querySameTypeProduct(params) {
    return request.post('/product/mall/searchSimilarProduct', params);
  },
  // 查询常采类目
  queryOftenTree(params) {
    return request.post('/product/category/queryOftenTree', params);
  },
  // 查询采购商常采类目
  queryPurchaseOftenCategory(params) {
    return request.post('/product/category/queryPurchaseOftenCategory', params);
  },
  // 添加采购商常采类目
  addPurchaseOftenCategory(params) {
    return request.post('/product/category/addPurchaseOftenCategory', params);
  },
  // 批量调价接口
  batchChangePrice(params) {
    return request.post('/product/companyCentralizedSku/changePrice', params);
  },
  // 商品导出接口
  exportCentralizedSku(params) {
    return request.post(
      '/product/companyCentralizedSku/exportCompanySku',
      params,
      { responseType: 'blob' }
    );
  },
  // 查询集采商品类目树接口
  queryCentralizedCategoryTreeByAgreementId(params) {
    return request.fetch(
      '/product/category/queryCentralizedCategoryTreeByAgreementId',
      params
    );
  },
  // 全部删除接口
  removeByCondition(params) {
    return request.post(
      '/product/companyCentralizedSku/removeByCondition',
      params
    );
  },
  // 批量移除（移除）接口
  centralizedBatchRemove(params) {
    return request.post('/product/companyCentralizedSku/batchRemove', params);
  },
  // 协议商品列表查询接口
  centralizedQuerySkuPage(params) {
    return request.post(
      '/product/companyCentralizedSku/queryCompanySkuPage',
      params
    );
  },
  // 添加商品接口
  centralizedBatchAdd(params) {
    return request.post('/product/companyCentralizedSku/batchAdd', params);
  },
  // 检查商品是否存在
  checkSkuExist(params) {
    return request.post('/product/centralizedSku/checkSkuExist', params);
  },

  // 未添加商品查询接口
  queryCentralizedSharePage(params) {
    return request.post(
      '/product/companyCentralizedSku/querySkuSharePage',
      params
    );
  },
  // 调价日志查询接口
  queryPriceChangeLog(params) {
    return request.fetch(
      `/product/companyCentralizedSku/queryPriceChangeLog`,
      params
    );
  },
  // 勾选全部商品添加接口
  addByCondition(params) {
    return request.post(
      '/product/companyCentralizedSku/addByCondition',
      params
    );
  },
  // 审核页面列表查询接口
  queryAuditSkuPage(params) {
    return request.post('/product/centralizedSku/querySkuPage', params);
  },
  // 导入商品模板下载接口
  downSkuTemplate(params) {
    return request.post('/product/centralizedSku/downSkuTemplate', params, {
      responseType: 'blob',
    });
  },
  // 导入调价模板下载接口
  downPriceTemplate(params) {
    return request.post('/product/centralizedSku/downPriceTemplate', params, {
      responseType: 'blob',
    });
  },
  // 商品清单的导出
  centralizedSkuExportCentralizedSku(params) {
    return request.post(
      '/product/centralizedSku/exportCentralizedSku',
      params,
      { responseType: 'blob' }
    );
  },
  // 查看导入结果
  centralizedSkuImportResult(params) {
    return request.fetch('/product/centralizedSku/importResult', params);
  },
  // 非标上下架列表-新接口
  queryCompanySkuPage(params) {
    return request.post('/product/skuNonstandard/queryCompanySkuPage', params);
  },

  // 非标商品上架
  skuPutawayBattchNonstandard(params) {
    return request.post('/product/skuNonstandard/skuPutawayBattch', params);
  },
  // 非标商品下架
  skuSoldOutBattchNonstandard(params) {
    return request.post('/product/skuNonstandard/skuSoldOutBattch', params);
  },

  // 非标商城
  skuDeleteBattchNonstandard(params) {
    return request.post('/product/skuNonstandard/skuDeleteBattch', params);
  },
  // 获取非标商品详情
  getCompanyOffStandardSkuInfo(params) {
    return request.fetch('/product/skuNonstandard/getCompanySkuInfo', params);
  },
  // 获取审核拒绝非标商品详情
  getCompanyOffStandardSkuInfoWithAudit(params) {
    return request.fetch(
      '/product/auditManagement/queryReleaseProductInfoById',
      params
    );
  },

  // 分类树
  companyCategoryTree(params) {
    return request.post('/product/companyCategory/companyCategoryTree', params);
  },

  queryZoneLabelList: (params) => {
    return request.fetch(
      `/product/productTags/queryZoneLabelList?${qs.stringify(params)}`
    );
  },
  // 商品标签 数据字典下拉框18
  queryTagLabelList: (params) => {
    return request.fetch(
      `/product/productTags/queryTagLabelList?${qs.stringify(params)}`
    );
  },
  // 原材料库存订单--mdm 品类
  selectCompanyCategorys: (params) => {
    return request.post(
      `/product/companyCategory/selectCategorysByParentId`,
      params,
      { preventRepeat: false }
    );
  },
  // 原材料库存订单--根据末级节点查全部mdm 品类
  selectCategoryRouteByCategoryId: (params) => {
    return request.post(
      `/product/category/selectCategoryRouteByCategoryId`,
      params
    );
  },
  // 搜索平台小类分类
  queryCategoryRouteList(params) {
    return request.post('/product/category/queryCategoryRouteList', params);
  },
  // 获得分类属性列表
  getCategoryAttributeList(params) {
    return request.post(
      '/product/category/selectCategoryAttributeList',
      params
    );
  },
  //采购合同上传和 附件 共同清单接口
  ruleQueryList(params) {
    return request.post('/ai-management/review/rule/queryList', params);
  },

};

export default server;
